<template>
<!-- 出口 -->
<div class="mapbox">
    <!-- {{parentObject}} -->
    <div class="maps">
        <div class="map" id="mapbox"></div>
        </div>
    </div>
</template>
    
<script>
import { map, loadMap } from "./map/mapbox";
import MapboxDirections from "@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions";
export default {
    components:{
    },
    props: {
        parentObject: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            end: {
                port: "",
                endaddress: "",
                distance: "",
                end_lat: "",
                end_lon: "",
                state_lat: "",
                state_lon: "",
            },
            select:6,
        }
    },
    methods: {
        // 点击按钮  传过来新的值
        initMapbox(state_lon, state_lat, end_lon, end_lat) {
            // parentObject.state_lon
            // parentObject.state_lat
            // parentObject.end_lon
            // parentObject.end_lat
            if (
                sessionStorage.getItem("cut") &&
                sessionStorage.getItem("cut") == "en-US"
            ) {
                loadMap("mapbox", "en-US");
            } else {
                loadMap("mapbox", "zh-Hans");
            }
            if (this.parentObject.select == 6) {
                map.setCenter([-97.74571788753173, 40.701712451168106]);
            } else if (this.parentObject.select == 7) {
                map.setCenter([-105.82299063528374, 56.355486258914766]);
            }
            map.setZoom(3); //设置缩放级别
            if (state_lon && state_lat && end_lon && end_lat) {
                map.on("load", () => {
                let start_point = [state_lon, state_lat];
                let end_point = [end_lon, end_lat];
                let mymap = new MapboxDirections({
                    accessToken:
                    "pk.eyJ1Ijoic3BlZWR5ZXRhIiwiYSI6ImNsd3NsMDFubzBjdXkyanB6Y254ZDRiOXIifQ.T4ALSK1WM-yYxO_5hLFMDQ",
                    unit: "metric", // metric | imperial
                    interactive: false,
                    profile: "mapbox/driving",
                    controls: {
                    inputs: false,
                    instructions: false,
                    profileSwitcher: false,
                    },
                });
                map.addControl(mymap, "top-left"); //添加控件
                mymap.setOrigin(start_point); //设置原点
                mymap.setDestination(end_point); //设置终点
                //点击地图时重置坐标
                // map.on('click', (e) => {
                // setTimeout(function() {
                // mymap.setOrigin(start_point); //设置原点
                // mymap.setDestination(end_point); //设置终点
                // }, 300);
                // });
                });
            }
        },
    },
    computed: {
        cutList() {
            return this.$t("m");
        },
    },
    mounted(){
        this.initMapbox();
    },
    watch:{
        // parentObject(val){    //message即为父组件的值，val参数为值
        //     //   this.childrenMessage = val    //将父组件的值赋给childrenMessage 子组件的值
        //     // this.initMapbox();

        // },
        parentObject: {
            handler(newVal) {
                this.initMapbox();
                if(newVal.state_lon!='' && newVal.state_lat!='' && newVal.end_lon!='' && newVal.end_lat!=''){
                    this.initMapbox(
                        newVal.state_lon,
                        newVal.state_lat,
                        newVal.end_lon,
                        newVal.end_lat
                    )
                }
            },
            deep: true
        }
      }
}
</script>
    
<style style lang="scss" scoped>
.mapbox {
  display: flex;
  justify-content: center;
  .maps {
    width: 100%;
    height: 100%;
    .map {
      width: 100%;
      height: 100%;
      ::v-deep .mapboxgl-ctrl-bottom-left {
        z-index: 0;
      }
      ::v-deep .mapboxgl-ctrl-bottom-right {
        z-index: 0;
      }
    }
  }
}
</style>